import { render, staticRenderFns } from "./UKbranchDetail.vue?vue&type=template&id=e11df9ba"
import script from "./UKbranchDetail.vue?vue&type=script&lang=js"
export * from "./UKbranchDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports